import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { actionsRow, actionBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var QuickActions = function QuickActions(_ref) {
  var canIssueCredits = _ref.canIssueCredits,
      isAdminOrTenantOrOwnerOrManager = _ref.isAdminOrTenantOrOwnerOrManager;
  var history = useHistory();
  return ___EmotionJSX("div", {
    style: actionsRow
  }, canIssueCredits && ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: actionBtn,
    onClick: function onClick() {
      return history.push('/credits/new');
    }
  }, ___EmotionJSX("i", {
    className: "las la-plus-circle"
  }), ___EmotionJSX("span", null, "\u041D\u043E\u0432 \u043A\u0440\u0435\u0434\u0438\u0442")), ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: actionBtn,
    onClick: function onClick() {
      return history.push('/credits');
    }
  }, ___EmotionJSX("i", {
    className: "las la-list"
  }), ___EmotionJSX("span", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u0438")), ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: actionBtn,
    onClick: function onClick() {
      return history.push('/payments');
    }
  }, ___EmotionJSX("i", {
    className: "las la-money-bill-wave"
  }), ___EmotionJSX("span", null, "\u041F\u043B\u0430\u0449\u0430\u043D\u0438\u044F")), isAdminOrTenantOrOwnerOrManager && ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: actionBtn,
    onClick: function onClick() {
      return history.push('/late-payments');
    }
  }, ___EmotionJSX("i", {
    className: "las la-exclamation-triangle"
  }), ___EmotionJSX("span", null, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u044F")), isAdminOrTenantOrOwnerOrManager && ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: actionBtn,
    onClick: function onClick() {
      return history.push('/given-payments');
    }
  }, ___EmotionJSX("i", {
    className: "las la-chart-bar"
  }), ___EmotionJSX("span", null, "\u0421\u043F\u0440\u0430\u0432\u043A\u0438")));
};

QuickActions.propTypes = {
  canIssueCredits: PropTypes.bool,
  isAdminOrTenantOrOwnerOrManager: PropTypes.bool
};
export default QuickActions;